import { Component } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { DialogConstant } from '../../../Constant';

import { AuthService } from '../../../service/auth.service';
import { LogService } from '../../../service/log.service';
import { DialogService } from '../../../service/dialog.service';
import { EventService } from '../../../service/event.service';

@Component({
    selector: 'app-deletedevice-modal',
    templateUrl: './deletedevice-modal.page.html',
    styleUrls: ['./deletedevice-modal.page.scss'],
})
export class DeletedeviceModalPage
{
    private devices = [];
    private delete_devices = [];
    private isdisabled = true;

    constructor(
        private navParams: NavParams,
        private auth: AuthService,
        private log: LogService,
        private dialog: DialogService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: `deletedevice-modal`, value: null});
        this.devices = this.navParams.data.devices;
    }

    deleteOnDeviceChange(id)
    {
        const index = this.delete_devices.indexOf(id);

        if (index >= 0) {
            this.delete_devices.splice(index, 1);
        } else {
            this.delete_devices.push(id);
        }

        if (this.delete_devices.length > 0) {
            this.setDisabled(false);
        } else {
            this.setDisabled(true);
        }
    }

    async deleteDevicereSend()
    {
        const btn1 = {
            text: DialogConstant.BUTTON_CANCEL,
            role: 'cancel'
        };

        const btn2 = {
            text: DialogConstant.BUTTON_OK,
            handler: () => {
                this.event.modal_subject.next({key: "closeModal", id: `deletedevice-modal`, value: { value: this.delete_devices }});
            }
        };

        this.dialog.confirm(DialogConstant.CONFIRM_TITLE, DialogConstant.UPDATE_PROFILE_DEVICE_COFIRM, [btn1, btn2]);
    }

    setDisabled(disable)
    {
        this.isdisabled = disable;
    }

    deleteDeviceClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: `deletedevice-modal`, value: null});
    }
}
